/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileJpe = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M13.502 15.517c0 .5-.147.89-.442 1.166-.29.276-.697.414-1.221.414-.212 0-.421-.024-.628-.07a1.769 1.769 0 0 1-.531-.193v-.945c.202.087.381.152.538.193.16.041.312.063.455.063.248 0 .435-.063.56-.187.128-.124.193-.304.193-.538v-2.54l-.918-.296v-.6h1.994zm2.698-3.534c.616 0 1.081.143 1.394.428.317.285.476.709.476 1.27 0 .372-.071.685-.214.938a1.327 1.327 0 0 1-.628.566c-.275.13-.619.194-1.028.194h-.724V17h-1.07v-5.017zm-.724 2.519h.503c.368 0 .628-.062.78-.187.156-.128.234-.34.234-.634 0-.3-.078-.511-.234-.635-.152-.124-.412-.186-.78-.186h-.503zm6.52-1.607H19.81v1.118h1.987v.91H19.81v1.166h2.255V17h-3.332v-5.017h3.264z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileJpe as FileJpe };
